import React from 'react';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import liabilityTypes from './liability-types';

const LiabilityTypeSelector = ({ selectedSubtype, onSubtypeChange, disabled }) => {
  const selectedLiabilityType = liabilityTypes[0];

  return (
    <FormControl fullWidth style={{ marginTop: '16px' }} disabled={disabled}>
      <InputLabel>Liability Subtype</InputLabel>
      <Select
        label="Liability Subtype"
        value={selectedSubtype}
        onChange={(e) => onSubtypeChange(e.target.value)}
      >
        {selectedLiabilityType?.subtypes?.map((subtype) => (
          <MenuItem key={subtype.value} value={subtype.value}>
            {subtype.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LiabilityTypeSelector;
